import axios from 'axios'

export const HTTP = axios.create({
  baseURL: (
    process.env.NODE_ENV === 'production' ? 'https://login.gecco-fahrschulen.de/login/api/v1/' : (
      process.env.NODE_ENV === 'development' ? 'http://fs.xel.one:8080/login/api/v1/' : (
        process.env.NODE_ENV === 'e2e-testing' ? 'https://dev.fahrschul-system.de/login/api/v1/' : ''
      )
    )
  )
})



// WEBPACK FOOTER //
// ./src/http-common.js